module.exports = __webpack_public_path__ + "img/HLM-logo.478e09ea.svg";